module.exports = __webpack_public_path__ + "static/4_SINGLE-96941cfd73ccf4cff888497dcb48260e.png";